import { Languages } from "../../enums/languages";


const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png", "application/pdf"]; 

const formErrorsLang = {
    "invalid-form": {
        [Languages.Hebrew]: { default: "טופס לא תקין, אנא בדוק את השדות המסומנים ונסה שוב" },
        [Languages.Arabic]: { default: "نموذج غير صالح، يرجى التحقق من الحقول المحددة والمحاولة مرة أخرى" },
        [Languages.English]: { default: "Invalid form, please check the highlighted fields and try again" }
    },
    "required": {
        [Languages.Hebrew]: { default: "שדה חובה!" },
        [Languages.Arabic]: { default: "حقل مطلوب" },
        [Languages.English]: { default: "Required field" }
    },
        "invalid-house-number": {
        [Languages.Hebrew]: { default: "מספר בית חייב להיות מספר שגדול מאפס" },
        [Languages.Arabic]: { default: "يجب أن يكون رقم المنزل رقماً أكبر من صفر" },
        [Languages.English]: { default: "House number must be a number greater than zero" }
    },
    "invalid-appartment-number": {
        [Languages.Hebrew]: { default: "מספר דירה חייב להיות מספר שגדול מאפס" },
        [Languages.Arabic]: { default: "يجب أن يكون رقم الشقة رقماً أكبر من صفر" },
        [Languages.English]: { default: "Apartment number must be a number greater than zero" }
    },
    "street-not-selected": {
        [Languages.Hebrew]: { default: "אנא בחר רחוב" },
        [Languages.Arabic]: { default: "يرجى اختيار الشارع" },
        [Languages.English]: { default: "Please select a street" }
    },
    "person-id-invalid": {
        [Languages.Hebrew]: { default: "מספר ת.ז אינו חוקי. צריך להכיל ספרת ביקורת" },
        [Languages.Arabic]: { default: "رقم الهوية غير صالح. يجب أن يحتوي على رقم تحقق" },
        [Languages.English]: { default: "Invalid ID number. It should contain a check digit" }
    },
    "invalid-email": {
        [Languages.Hebrew]: { default: "כתובת אימייל לא תקינה" },
        [Languages.Arabic]: { default: "عنوان بريد إلكتروني غير صالح" },
        [Languages.English]: { default: "Invalid email address" }
    },
    "moble-number": {
        [Languages.Hebrew]: { default: "מספר טלפון לא תקין" },
        [Languages.Arabic]: { default: "رقم هاتف غير صالح" },
        [Languages.English]: { default: "Invalid phone number" }
    },
    "only-digits-allowed": {
        [Languages.Hebrew]: { default: "רק ספרות מותרות" },
        [Languages.Arabic]: { default: "يسمح بالأرقام فقط" },
        [Languages.English]: { default: "Only digits allowed" }
    },
    "only-digits-allowed-and-dashes": {
        [Languages.Hebrew]: { default: "רק ספרות ומקפים מותרות" },
        [Languages.Arabic]: { default: "يسمح بالأرقام والشرطات فقط" },
        [Languages.English]: { default: "Only digits and dashes allowed" }
    },
    "only-english-and-hebrew-and-spaces": {
        [Languages.Hebrew]: { default: "רק אנגלית, עברית ורווחים מותרות" },
        [Languages.Arabic]: { default: "يسمح فقط بالإنجليزية والعبرية والمسافات" },
        [Languages.English]: { default: "Only English, Hebrew, and spaces allowed" }
    },
    "only-english-and-spaces": {
        [Languages.Hebrew]: { default: "רק אנגלית ורווחים מותרות" },
        [Languages.Arabic]: { default: "يسمح فقط بالإنجليزية والمسافات" },
        [Languages.English]: { default: "Only English and spaces allowed" }
    },
    "file": {
        "too-large": {
            [Languages.Hebrew]: { default: "הקובץ גדול מדי" },
            [Languages.Arabic]: { default: "الملف كبير جدًا" },
            [Languages.English]: { default: "The file is too large" }
        },
        "unsupported-format": {
            [Languages.Hebrew]: { default: `ניתן לעלות קבצים מסוג: ${SUPPORTED_FORMATS} בלבד.` },
            [Languages.Arabic]: { default: `يمكنك تحميل الملفات فقط من الأنواع التالية: ${SUPPORTED_FORMATS}.` },
            [Languages.English]: { default: `You can only upload files of the following types: ${SUPPORTED_FORMATS}.` }
        }
    }
}

export default formErrorsLang;